module.exports = __webpack_public_path__ + "ohen-znamenko-portskeho-vina_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/ohen-znamenko-portskeho-vina_2_after.jpg
// module id = 967
// module chunks = 0